import React from 'react';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { useStyles } from './ProcessIcon.styles';

interface ProcessesIconProps {
  letter: string;
  tooltip?: string;
  toolTipPlacement?: 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
}

const ProcessesIcon: React.FC<ProcessesIconProps> = ({ letter, tooltip, toolTipPlacement }) => {
  const classes = useStyles();
  return (
    <TooltipOne title={tooltip ? tooltip : ''} placement={toolTipPlacement} >
      <div className={classes.processIcon}>
        <span>{letter}</span>
      </div>
    </TooltipOne>
  );
};

export default ProcessesIcon;
